import { SVGProps } from 'react';

export const AskSpendBrain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="142"
    height="141"
    viewBox="0 0 142 141"
    fill="none"
    {...props}
  >
    <circle cx="71" cy="70.5" r="70.5" fill="currentColor" fillOpacity="0.03" />
    <circle cx="71.5" cy="71" r="61" fill="currentColor" fillOpacity="0.05" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.703 68.3584L88.1401 50.8594L81.5772 68.3584L64.0781 74.9213L81.5772 81.4842L88.1401 98.9833L94.703 81.4842L112.202 74.9213L94.703 68.3584Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.8602 48.1258L36.7344 53.0465L49.8602 57.9671L54.7808 71.0929L59.7075 57.9671L72.8273 53.0465L59.7075 48.1258L54.7808 35L49.8602 48.1258Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.3744 88.2962L37.8281 91.875L47.3744 95.4538L50.9531 105L54.5363 95.4538L64.0781 91.875L54.5363 88.2962L50.9531 78.75L47.3744 88.2962Z"
      fill="currentColor"
    />
  </svg>
);
